var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInconInspira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 63,
    viewBox: "0 0 196 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_456)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.902 37.803V18.9287H61.2339V37.803H56.902Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1466 37.803L71.2998 24.1585H71.1979V37.803H66.9679V18.9287H71.6993L84.2093 32.2219H84.3111V18.9287H88.5411V37.803H84.1544H84.1466Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8992 33.541C95.1604 34.0094 98.2859 34.7197 101.49 34.7197C104.694 34.7197 106.378 34.0406 106.378 32.3702C106.378 30.6997 104.38 30.2548 101.388 29.5757C101.364 29.5757 100.307 29.365 100.283 29.365C96.0769 28.4751 93.531 27.1716 93.531 24.1351C93.531 20.6069 96.4999 18.9365 102.594 18.9365C105.908 18.9365 108.877 19.4829 110.138 19.881L109.558 22.8082C107.616 22.3632 105.038 22.051 102.939 22.051C99.8683 22.051 98.2624 22.5974 98.2624 23.9868C98.2624 25.3762 100.025 25.8134 103.62 26.6798C103.675 26.6798 104.882 26.914 104.905 26.914C109.159 27.8819 111.313 29.3181 111.313 32.1438C111.313 35.9062 108.211 37.8186 101.905 37.8186C97.9647 37.8186 94.9959 37.1941 93.343 36.5384L93.8914 33.5566L93.8992 33.541Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.306 31.4647V37.803H115.974V18.9287H126.298C131.868 18.9287 134.547 20.4899 134.547 25.025C134.547 29.3103 132.001 31.4725 125.797 31.4725H120.306V31.4647ZM120.251 22.1915V28.2019H125.585C128.789 28.2019 130.003 27.234 130.003 25.1265C130.003 23.0189 128.844 22.1837 125.719 22.1837H120.251V22.1915Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.067 37.803V18.9287H143.399V37.803H139.067Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.133 18.9287H159.958C165.27 18.9287 167.549 20.7865 167.549 24.5332C167.549 27.2262 166.554 29.4118 162.896 30.2782L169.045 37.803H163.766L158.063 30.6607H153.465V37.803H149.133V18.9287ZM159.379 27.476C161.956 27.476 163.029 26.7188 163.029 24.783C163.029 23.0033 162.034 22.1915 159.222 22.1915H153.418V27.476H159.379Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.077 18.8975H186.569L196 37.7951H191.269L189.138 33.4005H178.21L176.056 37.7951H171.458L181.077 18.8975ZM187.595 30.1455L183.788 22.2695H183.655L179.738 30.1455H187.595Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.29576V1.31918C0 9.24199 4.50422 16.5481 11.7971 20.4588L30.4407 30.458C31.1143 30.7624 36.6212 33.7988 37.9373 36.3669V25.3218C37.9373 22.5664 36.4176 20.0061 33.9265 18.562L2.08369 0.195155C1.16718 -0.335634 0 0.281018 0 1.29576Z",
    fill: "#4CC9E9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M0 1.29576V1.31918C0 9.24199 4.50422 16.5481 11.7971 20.4588L30.4407 30.458C31.1143 30.7624 36.6212 33.7988 37.9373 36.3669V25.3218C37.9373 22.5664 36.4176 20.0061 33.9265 18.562L2.08369 0.195155C1.16718 -0.335634 0 0.281018 0 1.29576Z",
    fill: "url(#paint0_linear_174_456)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.7119C0 62.7188 1.17501 63.3433 2.08369 62.8125L33.95 44.2583C36.4254 42.8142 37.9373 40.2696 37.9373 37.522V36.3745C36.6291 33.8142 31.1222 30.7778 30.4407 30.4656H30.4485C31.3728 30.9651 31.3728 32.2141 30.4485 32.7136L11.4525 43.0172C7.90392 44.9374 5.04472 47.685 3.06287 50.9166C1.08885 54.1403 0 57.8481 0 61.7119Z",
    fill: "#0082CB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.5,
    d: "M0 61.7119C0 62.7188 1.17501 63.3433 2.08369 62.8125L33.95 44.2583C36.4254 42.8142 37.9373 40.2696 37.9373 37.522V36.3745C36.6291 33.8142 31.1222 30.7778 30.4407 30.4656H30.4485C31.3728 30.9651 31.3728 32.2141 30.4485 32.7136L11.4525 43.0172C7.90392 44.9374 5.04472 47.685 3.06287 50.9166C1.08885 54.1403 0 57.8481 0 61.7119Z",
    fill: "url(#paint1_linear_174_456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_174_456",
    x1: 34.3887,
    y1: 27.6011,
    x2: 10.2709,
    y2: 10.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_174_456",
    x1: 10.959,
    y1: 52.7041,
    x2: 34.0047,
    y2: 34.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInconInspira);
export default __webpack_public_path__ + "static/media/incon_inspira.8e194c0d801c8ba1353cf2273507c0f3.svg";
export { ForwardRef as ReactComponent };